(function () {
  // ページを読み込むときにSessionStorageから情報を取得
  window.addEventListener('DOMContentLoaded', function () {
    var bannerClosed = sessionStorage.getItem('bannerClosed');
    const banner_newmember = document.querySelector(".banner__newmember");
    if (bannerClosed === 'true') {
      if (banner_newmember) banner_newmember.style.display = 'none';
    } else {
      if (banner_newmember) banner_newmember.style.display = 'block';
    }
  });

  'use strict';

  window.theme = window.theme || {};

  //ハンバーガー
  document.addEventListener('DOMContentLoaded', function () {
    const menuButton = document.getElementById('menu-button');
    if (menuButton) {
      menuButton.addEventListener('click', function () {
        this.classList.toggle('active');
        document.body.classList.toggle('inhibit-scroll');
        document.getElementById('header_nav').classList.toggle('active');
      });

      document.getElementById('header_nav').addEventListener('click', function () {
        this.classList.remove('active');
        document.body.classList.remove('inhibit-scroll');
        document.getElementById('menu-button').classList.remove('active');
      });
    }
  });


  // スライダー
  // 日めくり
  const swiper = new Swiper('.tips__slider', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    grabCursor: true,
    loop: false,
    autoplay: false,
    speed: 100,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    navigation: {
      nextEl: '.mizkan__top__main__datebtn--next',
      prevEl: '.mizkan__top__main__datebtn--prev'
    }
  });

  const swiper02 = new Swiper('.news__slider', {
    slidesPerView: 'auto',
    centeredSlides: true,
    grabCursor: true,
    loop: true,
    autoplay: {
      delay: 6000,
    },
    speed: 100,

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });

  new Swiper('.tutorial_modal_slider_container', {
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  new Swiper('.login_modal_slider_container', {
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  new Swiper('.account_tutorial_modal_slider_container', {
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      clickable: true,
    },

    navigation: {
      nextEl: '.swiper-button-next--about',
      prevEl: '.swiper-button-prev--about'
    }
  });

  // チャレンジクックリスト　スペシャルトップ
  const challengeCooklistSpecialTopSwiper = new Swiper(
    '.cooklist_top_slider',
    {
      slidesPerPage: 1,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true, 
    },
    }
  )

  // SP版
  // var windowWidth = $(window).width();
  // var windowSm = 768;
  // if (windowWidth <= windowSm) {
  //   // チャレンジクックリスト
  //   new Swiper('.challengecooklist_slider', {
  //     // 次のクックリスト見える度
  //     slidesPerView: 1,
  //     // スライドの間隔
  //     spaceBetween: 10,
  //     grabCursor: true,
  //     loop: false,
  //     // ...swiperOptions,
  //   });
  // }

  const productPointSlider = new Swiper('.product_point_slider_container', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    grabCursor: true,
    slidesPerGroupAuto: 1,
    pagination: {
      el: '.swiper-pagination--product-point',
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true,
    }
  });

  // 新規会員登録訴求モーダルのスライダー
  const loginAppealSlider = new Swiper(".login_modal .account_tutorial_modal_slider_container", {
    slidesPerView: 'auto',
    grabCursor: true,
    centeredSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: '.swiper-pagination--login_appeal',
      type: 'fraction',
    },
    navigation: {
      nextEl: ".swiper-button-next--login",
      prevEl: ".swiper-button-prev--login",
      enabled: true
    },
  });


  // // スーコレクション
  // // カレンダー
  // const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  // const today = new Date();
  // // 月末だとずれる可能性があるため、1日固定で取得
  // var showDate = new Date(today.getFullYear(), today.getMonth(), 1);

  // 初期表示
  // window.onload = function () {
  //   showProcess(today, calendar);
  // };
  // 前の月表示
  // function prev() {
  //   showDate.setMonth(showDate.getMonth() - 1);
  //   showProcess(showDate);
  // }


  // 次の月表示
  // function next() {
  //   showDate.setMonth(showDate.getMonth() + 1);
  //   showProcess(showDate);
  // }

  // // カレンダー表示
  // function showProcess(date) {
  //   var year = date.getFullYear();
  //   var month = date.getMonth();
  //   const options = {
  //     year: 'numeric',
  //   }
  //   const dateString = today.toLocaleDateString('ja-JP-u-ca-japanese', options)
  //   document.querySelector('#su-year').innerHTML = year;
  //   document.querySelector('#su-year-jp').innerHTML = dateString;
  //   document.querySelector('#su-month').innerHTML = month + 1;
  //   // var calendar = createProcess(year, month);
  //   // document.querySelector('#calendar').innerHTML = calendar;
  // }


  // カレンダー作成
  // function createProcess(year, month) {
  //   // 曜日
  //   var calendar = "<table><tr class='dayOfWeek'>";
  //   for (var i = 0; i < week.length; i++) {
  //     calendar += "<th>" + week[i] + "</th>";
  //   }
  //   calendar += "</tr>";

  //   var count = 0;
  //   var startDayOfWeek = new Date(year, month, 1).getDay();
  //   var endDate = new Date(year, month + 1, 0).getDate();
  //   var lastMonthEndDate = new Date(year, month, 0).getDate();
  //   var row = Math.ceil((startDayOfWeek + endDate) / week.length);

  //   // 1行ずつ設定
  //   for (var i = 0; i < row; i++) {
  //     calendar += "<tr>";
  //     // 1colum単位で設定
  //     for (var j = 0; j < week.length; j++) {
  //       if (i == 0 && j < startDayOfWeek) {
  //         // 1行目で1日まで先月の日付を設定
  //         calendar += "<td class='disabled'>" + (lastMonthEndDate - startDayOfWeek + j + 1) + "</td>";
  //       } else if (count >= endDate) {
  //         // 最終行で最終日以降、翌月の日付を設定
  //         count++;
  //         calendar += "<td class='disabled'>" + (count - endDate) + "</td>";
  //       } else {
  //         // 当月の日付を曜日に照らし合わせて設定
  //         count++;
  //         if (year == today.getFullYear()
  //           && month == (today.getMonth())
  //           && count == today.getDate()) {
  //           calendar += "<td class='today'>" + count + "</td>";
  //         } else {
  //           calendar += "<td>" + count + "</td>";
  //         }
  //       }
  //     }
  //     calendar += "</tr>";
  //   }
  //   return calendar;
  // }

  // ミツカンchカテゴリーメニュー
  jQuery(function () {
    jQuery('.mizkan__mizkan-ch__cat-btn').click(function () {
      jQuery('.mizkan__mizkan-ch__cat-box').toggleClass('active');
    });
  });

  class YearJP {
    constructor() {
      document.querySelectorAll('[data-year-jp]')?.forEach(span => {
        span.innerText = (new Date(span.dataset.yearJp)).toLocaleDateString('ja-JP-u-ca-japanese', { year: 'numeric' })
      })
    }
  }

  window.addEventListener('DOMContentLoaded', e => {
    new YearJP;
  })

  window.theme = window.theme || {};
  window.theme.openModal = (id_modal) => {
    const $body = document.body;
    const $modal = document.querySelector(id_modal);
    if (!$modal) {
      throw new Error(`Selector ${id_modal} is not found.`);
    }

    // モーダルを閉じる
    $modal.addEventListener('click', function (event) {
      if (event.target.classList.contains('modal-close')) {
        $modal.classList.remove('active');
        $body.classList.remove('inhibit-scroll');
      }
    });

    // モーダル表示
    $modal.classList.add('active');
    $body.classList.add('inhibit-scroll');
  };

  class WishListToggle extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    async connectedCallback() {
      this.type = this.getAttribute('type');
      this.item = this.getAttribute('item');
      const { data } = await (document.body.classList.contains('customer-logged-in') && fetch(`${window.AppProxyPath}/api/customers/wishlists/${this.type}/items/${this.item}`).then(res => res.json()));
      this.active = !!data;
      this.active && this.classList.add('active');
      this.initListener();
    }

    initListener() {
      this.addEventListener('click', e => {
        e.preventDefault();

        if (!document.body.classList.contains('customer-logged-in')) {
          window.theme.openModal('#modal_login_appeal');
        } else {
          this.classList.toggle('active');
          clearTimeout(this.timer)
          this.timer = setTimeout(() => this.onSubmit(e), 500);
        }
      })
    }

    async onSubmit() {
      const active = this.classList.contains('active');
      if (active == this.active) return;
    
      console.log(this.type);
    
      const method = active ? 'put' : 'delete';
      try {
        const response = await fetch(`${window.AppProxyPath}/api/customers/wishlists/${this.type}/items/${this.item}`, { method });
        if (response.ok) {
          this.active = active;
        } else {
          throw new Error('Failed to update wishlist');
        }
      } catch (error) {
        open_modal_error('#error_modal');
      }
    }
  }

  customElements.define('wishlist-toggle', WishListToggle);

  class SwiperCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const mediaThreshold = this.getAttribute('breakpoint');
      const swiperOptions = JSON.parse(this.getAttribute('options') || "{}");

      this.innerHTML = `
        <div class="swiper-container swiper-carousel__inner" style="overflow: hidden;">
          <div class="swiper-wrapper">
            ${this.innerHTML}
          </div>
        </div>
      `;

      if (!!mediaThreshold && window.innerWidth < Number(mediaThreshold)) {
        this.createSwiper(swiperOptions);
      }

      window.addEventListener('resize', () => {
        if (!!mediaThreshold && Number(mediaThreshold) <= window.innerWidth) {
          !!this.carousel && this.carousel.destroy(false, true);
        } else {
          this.createSwiper(swiperOptions);
        }
      }, false);
    }

    createSwiper(swiperOptions = {}) {
      this.isLoadingItems = false;
      this.carousel = new Swiper(this.querySelector('.swiper-container'), {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        loop: false,
        ...swiperOptions,

        on: {
          reachEnd: () => {
            if (this.parentElement.getAttribute('type') === 'cooklist' || this.parentElement.getAttribute('type') === 'cookrecipe' || this.parentElement.getAttribute('type') === 'mycooklist' || this.parentElement.getAttribute('type') === 'mycookrecipe') {
              this.loadMoreItems();
            }
          }
        }
      });
    }

    loadMoreItems() {
      if (this.isLoadingItems) return;

      this.isLoadingItems = true;
      const wishlistItemsElement = this.closest('wishlist-items');
      if (wishlistItemsElement) {
        wishlistItemsElement.readMoreCooklistSP().finally(() => {
          this.isLoadingItems = false; // ロード完了後にフラグをリセット
        });
      } else {
        // 念のため、wishlistItemsElementがない場合もフラグをリセット
        this.isLoadingItems = false;
      }
    }
  }

  customElements.define('swiper-carousel', SwiperCarousel);

  class swiperCarouselMycooklistAddList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.innerHTML = `
        <div class="swiper-container swiper-carousel__inner" style="overflow: hidden;">
          <div class="swiper-wrapper">
            ${this.innerHTML}
          </div>
        </div>
      `;

      this.createSwiper();
    }

    createSwiper() {
      this.carousel = new Swiper(this.querySelector('.swiper-container'), {
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        loop: false,
        breakpoints: {
          768: {
            spaceBetween: 70,
          }
        }
      });
    }
  }

  customElements.define('swiper-carousel-mycooklist-add-list', swiperCarouselMycooklistAddList);

  class CustomFormElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector('form')?.addEventListener('submit', async event => {
        event.preventDefault();



        const data = Object.fromEntries(new FormData(this.querySelector('form')));

        console.log(data)

        const response = await fetch(this.getAttribute('action'), {
          method: this.getAttribute('method') || 'get',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });

        if (response?.ok) {
          console.log(await response.json())
        }
      })
    }
  }

  customElements.define('custom-form', CustomFormElement);

  document.addEventListener('DOMContentLoaded', function () {
    var closeButton = document.getElementById('closeButton');
    var bannerNewMember = document.querySelector(".banner__newmember");

    if (closeButton && bannerNewMember) {
      closeButton.addEventListener('click', function () {
        bannerNewMember.style.display = 'none';
        sessionStorage.setItem('bannerClosed', 'true');
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var suchanHeadSet = document.querySelector('.suchan-headset');
    var suchanComment = document.querySelector('#suchan_comment p');
    if (suchanHeadSet && suchanComment) {
      let common_comments = suchanComment.getAttribute('common-comments').split('@');
      // document.getElementById('suchan_comment').addEventListener('click', function() {
      //   document.getElementById('suchan_img').click();
      // });
      document.getElementById('suchan_img').addEventListener('click', function () {
        suchanComment.innerText = common_comments[Math.floor(Math.random() * common_comments.length)];
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    var suchanImg = document.getElementById('suchan_img');
    var suchanComment = document.querySelector('#suchan_comment p');
    if (suchanImg && suchanComment) {
      let common_comments = suchanComment.getAttribute('common-comments').split('@');
      suchanComment.addEventListener('click', function () {
        suchanComment.innerText = common_comments[Math.floor(Math.random() * common_comments.length)];
      });
    }
  });

  // line連携
  const changeText = '<span>LINEと連携する</span>';
  const addEl = '<span class="release-test-top">LINE連携済</span><span class="release-test-bottom">解除はこちらから</span>';
  const lineBtns = document.querySelectorAll('.line_btn_box');
  document.addEventListener("DOMContentLoaded", function () {
    lineBtns.forEach(lineBtn => {
      setTimeout(() => {
        let lineTextEl = lineBtn.querySelector('.socialplus-association-button');
        let lineText;
        if (lineTextEl) {
          lineText = lineTextEl.getAttribute('aria-label');
        }
        if (lineTextEl) {
          if (lineText.includes('連携する')) {
            lineTextEl.innerHTML = changeText;
            lineTextEl.closest('.socialplus-association-component').classList.add('show');
            lineTextEl.closest('.socialplus-association-row').style.opacity = 1;
          } else if (lineText.includes('連携を解除')) {
            if (document.querySelector('.line_btn_info')) {
              document.querySelector('.line_btn_info').setAttribute('hidden', true);
              lineBtn.style.paddingTop = 0;
            }
            lineTextEl.innerHTML = addEl;
            lineTextEl.closest('.socialplus-association-component').classList.add('release');
            lineTextEl.closest('.socialplus-association-row').style.opacity = 1;
          }
        }
      }, 2300)
    })

    const intervalId = setInterval(() => {
      const lineBtns = document.querySelectorAll('.line_btn_box');
      lineBtns.forEach(lineBtn => {
        let lineTextEl = lineBtn.querySelector('.socialplus-association-button');
        if (lineTextEl) {

          if (lineTextEl.textContent.includes('連携する')) {
            lineTextEl.innerHTML = changeText;
          } else if (lineTextEl.textContent.includes('解除する')) {
            lineTextEl.innerHTML = addEl;
          }
        }
      })
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 7000);
  })
})();


(function() {
  // password.liquidページでない場合のみスクリプトを実行
  if (!window.location.pathname.includes('password')) {
    const aboutModal = document.querySelector('.about_modal');
    const aboutCloseBtns = document.querySelectorAll('.about_modal .first_visit_tutorial_close');
    const aboutModalClosed = localStorage.getItem('aboutModalClosed');

    if (!aboutModalClosed) {
      aboutModal.classList.add('active');
    }

    if (aboutCloseBtns.length > 0) {
      aboutCloseBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          aboutModal.classList.remove('active');
          localStorage.setItem('aboutModalClosed', 'true');
        });
      });
    }
  }
})();

function open_modal_error(id_modal) {
  const modal = document.querySelector(id_modal);

  const closeButton = modal.querySelector('.btn_gray');
  closeButton.addEventListener('click', function () {
      modal.classList.remove('open');
  });

  modal.classList.add('open');
}

document.addEventListener('DOMContentLoaded', function() {
  var backButton = document.getElementById('backToReferrer');
  if (backButton) {
      backButton.addEventListener('click', function() {
          window.location.reload();
      });
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/policies/terms-of-service') {
      window.location.href = '/pages/lp-policy/';
  }
});